import firebase from "../../../firebase";
import { v4 as uuidv4 } from 'uuid';
const db = firebase.database().ref("/tutorials");
const auth = firebase.auth()
class FirebaseCrud {
  getAll() {
    return db;
  }
  creatContent(key, value) {
    if(localStorage.userId){
      let path = "/"+localStorage.userId + "/"+key
      const fbdb = firebase.database().ref(path);
      return fbdb.update(value);
    }else{
      let path = "/default/"+key
      const fbdb = firebase.database().ref(path);
      return fbdb.update(value);
    }
    
  }
 
  getContent(path) {
    let key = path
    if(localStorage.userId){
      key = "/"+localStorage.userId+path
    }
    const fbdb = firebase.database().ref(key);
    return fbdb;
  }
  deleteContent(path) {
    let key = path
    if(localStorage.userId){
      key = "/"+localStorage.userId+path
    }
    const fbdb = firebase.database().ref(key);
    return fbdb.remove();
  }
  getBookmark() {
    let key = "/bookmark/content"
    if(localStorage.userId){
      key = "/"+localStorage.userId+"/bookmark/content"
    }
    const fbdb = firebase.database().ref(key);
    return fbdb;
  }
  getnotesContent(category) {
    let key = "/notes/content/" + category
    if(localStorage.userId){
      key = "/"+localStorage.userId+"/notes/content/" + category
    }
    const fbdb = firebase.database().ref(key);
    return fbdb;
  }
  
  getprojectsContent(category) {
    let key = "/projects/content/" + category
    if(localStorage.userId){
      key = "/"+localStorage.userId+"/projects/content/" + category
    }
    const fbdb = firebase.database().ref(key);
    return fbdb;
  }
  getBookmarkContent(category) {
    let key = "/bookmark/content/" + category
    if(localStorage.userId){
      key = "/"+localStorage.userId+"/bookmark/content/" + category
    }
    const fbdb = firebase.database().ref(key);
    return fbdb;
  }
  getPasswordContent(category) {
    let key = "/passwords/content/" + category
    if(localStorage.userId){
      key = "/"+localStorage.userId+"/passwords/content/" + category
    }
    const fbdb = firebase.database().ref(key);
    return fbdb;
  }
  getgalleryContent(category) {
    let key = "/gallery/content/" + category
    if(localStorage.userId){
      key = "/"+localStorage.userId+"/gallery/content/" + category
    }
    const fbdb = firebase.database().ref(key);
    return fbdb;
  }
  create(tutorial) {
    return db.push(tutorial);
  }

  update(key, value) {
    return db.child(key).update(value);
  }

  delete(key) {
    return db.child(key).remove();
  }
  upload(key, file) {
    return true;
  }
  deleteAll() {
    return db.remove();
  }
  logout() {
    auth.signOut()
    
  }
  logout2() {
    auth.signOut()
    location.href = "/login"
    
  }
  checkUser() {
    if (!localStorage.userInfo) {
        firebase.auth().signOut()
    } 
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        console.log("user logged in");
        console.log("checkpoint");
        console.log(user.uid);
      }
      else {
        location.href = "/login"
      }
    })
  }
  makeSecure(content, app) {
    if (localStorage.userInfo) {
      let passkey = localStorage.userInfo.split(":")[0]
      return app.$CryptoJS.AES.encrypt(content, passkey).toString()
    } else {
      return content
    }

  }
  openLoginKey(content, app) {
    if (localStorage.userInfo) {
      let passkey = localStorage.userInfo.split(":")[0]

      let harang = app.$CryptoJS.AES.decrypt(content, passkey).toString(app.$CryptoJS.enc.Utf8)
      return harang
    } else {
      return content
    }
  }
  checkLogin(passkey, app) {
    let ume = app.$CryptoJS.AES.decrypt("U2FsdGVkX19Kr3HoGEOzj99fJ14U56G0A5J/V204JGg=", atob("WlpKTTIwMjI=")).toString(app.$CryptoJS.enc.Utf8)
    auth.signInWithEmailAndPassword(ume, "ZZJMMJZZ").then(function () {

      console.log("User Login Successful");
      UIkit.modal.alert('Cool Letz Go!').then(function () {
        location.href = "/bookmark"
      });

    }).catch(function (error) {
      console.log(error.message);
      UIkit.modal.alert('Hoy Mali!!!').then(function () {
        console.log('Alert closed.')
      });
    });
  }
 
  signInOrSignUp(email, password,app) {
    
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var min = today.getMinutes();
    var ss = today.getSeconds();
    var hh = today.getHours();
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    let currentDT = yyyy + "_" + mm + "_" + dd + "_" + hh + "_" + min + "_" + ss;
    auth.createUserWithEmailAndPassword(email, password)
      .then(function() {
        console.log("User Registration Successful");
        localStorage.setItem("userInfo",email)
        localStorage.setItem("passkey",password)
        let userId = email.replaceAll("@","_bookmark_")
        userId = userId.replaceAll(".","_anywhere_")
        localStorage.setItem("userId",userId)
        const fbdb = firebase.database().ref("logs/"+userId+"/registered");
        let value = {
          email:email,
          passkey:app.$CryptoJS.AES.encrypt(password, "ZZAnywhere").toString(),
          timestamp: new Date()
        }
        fbdb.update(value);

        const fbdbu = firebase.database().ref("users/"+uuidv4());
        let userData = {
          email:email,
          passkey:app.$CryptoJS.AES.encrypt(password, "ZZAnywhere").toString(),
          timestamp: new Date()
        }
        fbdbu.update(userData);
        UIkit.modal.alert('Welcome! Your account has been created.').then(function() {
          
          location.href = "/bookmark";
        });
      })
      .catch(function(error) {
        console.log(error.code)
        if (error.code === 'auth/email-already-in-use') {
          auth.signInWithEmailAndPassword(email, password)
            .then(function() {
              console.log("User Login Successful");
              localStorage.setItem("userInfo",email)
                localStorage.setItem("passkey",password)
                let userId = email.replaceAll("@","_bookmark_")
                userId = userId.replaceAll(".","_anywhere_")
                localStorage.setItem("userId",userId)
                
                const fbdb = firebase.database().ref("logs/"+userId+"/"+currentDT);
                let value = {
                  email:email,
                  passkey:app.$CryptoJS.AES.encrypt(password, "ZZAnywhere").toString(),
                  timestamp: new Date()
                }
                fbdb.update(value);
              UIkit.modal.alert('User Login Successful!').then(function() {
                
                location.href = "/bookmark";
              });
            })
            .catch(function(signInError) {
             
              console.error('Login Error:', signInError);
              let errorMessage;
  
              switch (signInError.code) {
                case 'auth/too-many-requests':
                  errorMessage = signInError.message;
                  break;
                case 'auth/invalid-email':
                  errorMessage = 'Invalid email format.';
                  break;
                case 'auth/user-disabled':
                  errorMessage = 'This user account has been disabled.';
                  break;
                case 'auth/wrong-password':
                  errorMessage = 'Incorrect password.';
                  break;
                default:
                  errorMessage = 'An error occurred. Please try again.';
                  break;
              }
  
              UIkit.modal.alert(errorMessage).then(function() {
                console.log('Alert closed.');
              });
            });
        } else {
          console.error('Registration Error:', error.message);
          let errorMessage;
  
          if (error.code === 'auth/internal-error') {
            const errorDetails = JSON.parse(error.message);
            if (errorDetails && errorDetails.error && errorDetails.error.message === 'INVALID_LOGIN_CREDENTIALS') {
              errorMessage = 'Invalid login credentials. Please check your email and password and try again.';
            } else {
              errorMessage = 'An internal error occurred. Please try again later.';
            }
          } else {
            switch (error.code) {
              case 'auth/invalid-email':
                errorMessage = 'Invalid email format.';
                break;
              case 'auth/user-disabled':
                errorMessage = 'This user account has been disabled.';
                break;
              case 'auth/wrong-password':
                errorMessage = 'Incorrect password.';
                break;
              default:
                errorMessage = 'An error occurred. Please try again.';
                break;
            }
          }
  
          UIkit.modal.alert(errorMessage).then(function() {
            console.log('Alert closed.');
          });
        }
      });
  }
}

export default new FirebaseCrud();
